var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecordFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20a8 8 0 1 0 0-16.001A8 8 0 0 0 12 20Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.233.026c2.779.17 5.384 1.537 7.294 3.417C22.784 5.835 24 8.739 24 12.156c0 2.734-1.042 5.296-2.779 7.517-1.736 2.05-4.167 3.588-6.946 4.1-2.779.513-5.557.172-7.988-1.195-2.432-1.367-4.342-3.417-5.384-5.98-1.042-2.563-1.215-5.467-.347-8.03.868-2.733 2.431-4.955 4.862-6.492C7.676.538 10.455-.145 13.233.026Zm.868 22.04c2.258-.513 4.342-1.71 5.905-3.589 1.39-1.879 2.257-4.1 2.084-6.492 0-2.733-1.042-5.467-2.953-7.346-1.736-1.709-3.82-2.734-6.251-2.905-2.258-.17-4.689.342-6.6 1.709-1.91 1.366-3.299 3.246-3.993 5.638-.695 2.22-.695 4.613.347 6.834 1.042 2.22 2.605 3.93 4.689 5.125a9.44 9.44 0 0 0 6.772 1.025Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordFilled);
export default __webpack_public_path__ + "static/media/record-filled.acf185ad.svg";
export { ForwardRef as ReactComponent };